import { createStyles } from '@mantine/core';

export const useStyles = createStyles(() => {
  return {
    tooltip: {
      padding: 0,
      borderRadius: 8,
    },
  };
});
